import React from 'react'
import { Modal, Backdrop, Fade } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import TemplatePreviewPage from 'pages/template-preview-page'

const useStyles = makeStyles(() => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0
    },
    backdrop: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)'
    },
    modalContent: {
        width: '100vw',
        height: '100vh',
        outline: 'none',
        overflow: 'hidden',
        position: 'relative'
    }
}))

interface TemplatePreviewModalProps {
    open: boolean
    onClose: () => void
    imageUrlsData: string[]
    loading: boolean
    onCancel: () => void
    templateOptions?: any[]
    templateOption?: any
    systemTemplate?: any
    setTemplateOption?: (template: any) => void
    handleLoadMore?: () => void
    isLoading?: boolean
    hasMoreTemplates?: boolean
    handleGetTemplatePreview?: (templateId: string) => void
    previewSelection?: any
    setPreviewSelection?: (template: any) => void
    userPreferredTemplateResponse?: any
}

const TemplatePreviewModal: React.FC<TemplatePreviewModalProps> = ({
    open,
    onClose,
    imageUrlsData,
    loading,
    onCancel,
    systemTemplate,
    templateOptions,
    templateOption,
    setTemplateOption,
    handleLoadMore,
    isLoading,
    hasMoreTemplates,
    handleGetTemplatePreview,
    previewSelection,
    setPreviewSelection,
    userPreferredTemplateResponse
}) => {
    const classes = useStyles()

    const handleCancel = () => {
        onCancel()
        onClose()
        setPreviewSelection?.({}) // Reset previewSelection when modal is closed
    }

    const handleClose = () => {
        onClose()
        setPreviewSelection?.({}) // Reset previewSelection when modal is closed
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            className={classes.modal}
            BackdropComponent={Backdrop}
            BackdropProps={{
                className: classes.backdrop
            }}
            closeAfterTransition
        >
            <Fade in={open}>
                <div className={classes.modalContent}>
                    <TemplatePreviewPage
                        imageUrlsData={imageUrlsData}
                        loading={loading}
                        onClose={handleClose}
                        onCancel={handleCancel}
                        systemTemplate={systemTemplate}
                        templateOptions={templateOptions}
                        templateOption={templateOption}
                        setTemplateOption={setTemplateOption}
                        handleLoadMore={handleLoadMore}
                        isLoading={isLoading}
                        hasMoreTemplates={hasMoreTemplates}
                        handleGetTemplatePreview={handleGetTemplatePreview}
                        previewSelection={previewSelection}
                        setPreviewSelection={setPreviewSelection}
                        userPreferredTemplateResponse={userPreferredTemplateResponse}
                        isDesktop={true} // Force desktop behavior
                    />
                </div>
            </Fade>
        </Modal>
    )
}

export default TemplatePreviewModal
